










import { Vue, Component } from 'vue-property-decorator';
import DescargasActividad from '@/pantallas/DescargaActividades/DescargasActividad.vue';
import { fetchProveedoresGps } from '@/reusable/proveedorGps/fetchProveedoresGps';
import { fetchClientesProveedorGps } from '@/reusable/proveedorGps/fetchClientesProveedorGps';

@Component({
  components: { DescargasActividad },
})
export default class DescargasActividadPantalla extends Vue {
  created() {
    fetchProveedoresGps.cache.clear();
    fetchClientesProveedorGps.cache.clear();
  }
}
